import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingIndicatorComponent } from './loading-indicator/loading-indicator.component';
import { TrimDirective } from './_directives/trim.directive';
import { ScrollToTopBtnComponent } from './scroll-to-top-btn/scroll-to-top-btn.component';
import { FileUploadModule } from 'primeng/fileupload';
import { DragNDropDirective } from './_directives/drag-n-drop.directive';
import { NgxPaginationModule } from 'ngx-pagination';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';

@NgModule({
  declarations: [
    LoadingIndicatorComponent,
    TrimDirective,
    DragNDropDirective,
    ScrollToTopBtnComponent
  ],
  imports: [
    CommonModule,
    NgxPaginationModule,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    LoadingIndicatorComponent,
    ScrollToTopBtnComponent,
    TrimDirective,
    DragNDropDirective,
    FileUploadModule,
    NgxPaginationModule,
    CalendarModule,
    DialogModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule
  ]
})
export class SharedModule { }
